import { api } from "@mb";

const libraryService = {
  getLibraryList: async (query) => api.getPagedList(`api/Library/paged`, query),
  getlibraryItemWithPlayList: async (query) =>
    api.get(`api/Library/${query.id}`),
};

export default libraryService;
